import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { HomeControllerModule } from './controllers/HomeController';

export const HomeView = angular
  .module('acme.view.home', [uiRouter, 'ui.bootstrap', HomeControllerModule])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const home = {
      name: 'home',
      url: '/register',
      abstract: true,
      views: {
        main: {
          controller: 'HomeController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
      },
      resolve: {
        css: [
          '$q',
          function ($q) {
            const q = $q.defer();

            // Usage
            if ($('#splash-css').length === 0) {
              require('./../../../assets/less/splash/splash.less');
            }
            q.resolve('done');

            return q.promise;
          },
        ],
      },
    };

    const homeDefault = {
      name: 'home.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/home/home.tpl.html',
        },
      },
      data: {
        pageTitle: 'Welcome',
      },
    };

    $stateProvider.state(home).state(homeDefault);
  }).name;
